import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import laptop from 'assets/images/laptop.svg'
import type { PDFDocumentProxy } from 'pdfjs-dist'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'
import { download } from 'modules/core/lib/download'
import i18n from 'modules/core/lib/i18n'

import { useFeatures } from 'modules/core/hooks/useFeatures'

import PdfViewer from 'modules/documents/components/PdfViewer'
import PdfViewerF0 from 'modules/documents/components/PdfViewer/PdfViewerF0'
import { ControllerType, ScaleType } from 'modules/documents/components/PdfViewer/types'

import './index.styles.css'
export interface Props {
  mimeType: string
  url: string
  filename: string
  isUrlAbsolute: boolean
  isPending?: boolean
  fillable?: boolean
  page?: number
  pagesToDisplay?: number[]
  initialScale?: ScaleType
  onCloseFillableModal?: () => void
  onPdfLoaded?: (pdf: PDFDocumentProxy) => void
  onSaveFile?: (blob: Blob) => Promise<void>
  onSavingStatusChange?: (value: boolean) => void
  onPrintPdf?: () => void
  onDownloadPdf?: () => void
  onPdfPageChange?: (page: number) => void
  controllers?: ControllerType[]
}

const NoImagePreview = (props: Props) => (
  <Box width="full" textAlign="center" padding="s32" gap="s12" alignItems="center">
    <Box justifyContent="center" alignItems="center">
      <img src={laptop} />
    </Box>
    <Text.Header2>{i18n.t('documents.no_preview')}</Text.Header2>
    <Text.Normal>{i18n.t('documents.no_preview_description')}</Text.Normal>
    <Button onClick={() => download(props.url, props.filename)} iconName="download">
      {i18n.t('documents.download')}
    </Button>
  </Box>
)

const buildAbsoluteUrl = (partialUrl: string, isPending: boolean): string => {
  const pendingParam = isPending ? '&by_pending_assignment=true' : ''
  const urlString = `${partialUrl}&inline=true${pendingParam}`

  return buildUrl(urlString)
}

const FileViewer = (props: Props) => {
  const { mimeType, url, isUrlAbsolute, isPending = false, onPdfPageChange, pagesToDisplay } = props
  const src = isUrlAbsolute ? url : buildAbsoluteUrl(url, isPending)
  const { has_dev_documents_data_collection } = useFeatures(['dev_documents_data_collection'])

  if (mimeType === 'application/pdf') {
    const PdfViewerComponent = has_dev_documents_data_collection ? PdfViewerF0 : PdfViewer

    return (
      <Box width="full" height="full">
        <PdfViewerComponent
          url={src}
          filename={props.filename}
          fillable={props.fillable}
          page={props.page}
          pagesToDisplay={pagesToDisplay}
          initialScale={props.initialScale}
          onPdfLoaded={props.onPdfLoaded}
          onSaveFile={props.onSaveFile}
          onSavingStatusChange={props.onSavingStatusChange}
          onDownloadPdf={props.onDownloadPdf}
          onPrintPdf={props.onPrintPdf}
          onCloseFillableModal={props.onCloseFillableModal}
          controllers={props.controllers}
          onPageChange={onPdfPageChange}
        />
      </Box>
    )
  } else if (mimeType?.match(/image/) && !mimeType?.match(/heic|heif/i)) {
    return (
      <Box alignItems="center">
        <img src={src} className={'FileViewer_image'} />
      </Box>
    )
  } else {
    return <NoImagePreview {...props} />
  }
}

export default observer(FileViewer)
